import { render, staticRenderFns } from "./violation.vue?vue&type=template&id=b43f6920&scoped=true&"
import script from "./violation.vue?vue&type=script&lang=js&"
export * from "./violation.vue?vue&type=script&lang=js&"
import style0 from "./violation.vue?vue&type=style&index=0&id=b43f6920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43f6920",
  null
  
)

export default component.exports